import { render } from "./BannerInfo.vue?vue&type=template&id=859c0f90&scoped=true&ts=true"
import script from "./BannerInfo.vue?vue&type=script&lang=ts"
export * from "./BannerInfo.vue?vue&type=script&lang=ts"

import "./BannerInfo.vue?vue&type=style&index=0&id=859c0f90&lang=scss&scoped=true"

import exportComponent from "G:\\Runze\\rzhy_main_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-859c0f90"]])

export default __exports__